import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "log-book" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Zelda"),
  /*#__PURE__*/_createElementVNode("span", null, "LogBook")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "no-results"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "No Results (╯°□°)╯︵ ┻━┻", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "results-container"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "results-header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Results"),
  /*#__PURE__*/_createElementVNode("div", { class: "divider" })
], -1)
const _hoisted_10 = {
  key: 1,
  class: "loading-placeholder"
}
const _hoisted_11 = { class: "pagination" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]

import { ref, computed, onMounted, watch } from 'vue';
import NavBar from '@/components/NavBar.vue';
import SearchBar from '@/components/SearchBar.vue';
import ResultCard from '@/components/ResultCard.vue';
import zeldaService from '@/services/zeldaService';

interface Result {
  id: string;
  name: string;
  description: string;
}

const pageSize = 6;

export default /*#__PURE__*/_defineComponent({
  __name: 'LogBook',
  setup(__props) {

const searchQuery = ref('');
const searchKey = ref('');
const navItems = ['Game', 'Characters', 'Items', 'Monsters'];
const selectedItem = ref('Items');
const results = ref<Result[]>([]);
const currentPage = ref(1);
const loading = ref(false);

const totalPages = computed(() => Math.ceil(results.value.length / pageSize));

const paginatedResults = computed(() => {
  const start = (currentPage.value - 1) * pageSize;
  const end = start + pageSize;
  return results.value.slice(start, end);
});

const fetchResults = async () => {
  loading.value = true;
  results.value = await zeldaService.fetchResults(
    selectedItem.value,
    searchQuery.value,
  );
  loading.value = false;
};

const performSearch = () => {
  currentPage.value = 1;
  searchKey.value = searchQuery.value;
  fetchResults();
};

const updateSearchQuery = (newQuery: string) => {
  searchQuery.value = newQuery;
};

const selectItem = (item: string) => {
  selectedItem.value = item;
  currentPage.value = 1;
  searchQuery.value = '';
  searchKey.value = '';
  fetchResults();
};

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value -= 1;
    fetchResults();
  }
};

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value += 1;
    fetchResults();
  }
};

onMounted(() => {
  fetchResults();
});

watch([selectedItem], fetchResults);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(NavBar, {
          navItems: navItems,
          selectedItem: selectedItem.value,
          onSelectItem: selectItem
        }, null, 8, ["selectedItem"]),
        _createVNode(SearchBar, {
          initialQuery: searchQuery.value,
          "onUpdate:query": updateSearchQuery,
          onSearch: performSearch
        }, null, 8, ["initialQuery"]),
        (paginatedResults.value.length === 0 && !loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (!loading.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: selectedItem.value + '_' + currentPage.value + '_' + searchKey.value,
                        class: "results-grid"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedResults.value, (result) => {
                          return (_openBlock(), _createBlock(ResultCard, {
                            key: result.id,
                            id: result.id,
                            name: result.name,
                            description: result.description
                          }, null, 8, ["id", "name", "description"]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, "Loading..."))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: prevPage,
                  disabled: currentPage.value === 1 || loading.value,
                  class: "pagination-button"
                }, " Prev ", 8, _hoisted_12),
                _createElementVNode("button", {
                  onClick: nextPage,
                  disabled: currentPage.value === totalPages.value || loading.value,
                  class: "pagination-button"
                }, " Next ", 8, _hoisted_13)
              ])
            ]))
      ])
    ])
  ]))
}
}

})